// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2CHFV","load7":"Loader_load7__3LMkZ"};